import React from "react";

export const Divider = () => {
  return <div className="divider m-0"></div>;
};
